<app-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [header]="(mode === 'edit' ? ('UPLOAD_IMAGES.MODAL_TAGS_EDIT_TITLE' | translate) : ('UPLOAD_IMAGES.MODAL_TAGS_CREATE_TITLE' | translate))"
  [width]="'520px'"
  [modal]="true"
  [closable]="true"
  [showFooter]="true"
  [dismissableMask]="true"
  (onHide)="close()"
>
  <ng-template #content>
    <div class="tag-form">
      <label class="field-label" for="tag-name">
        {{ 'UPLOAD_IMAGES.MODAL_TAGS_NAME' | translate }}
        <span class="required">*</span>
      </label>
      <input
        id="tag-name"
        type="text"
        pInputText
        [(ngModel)]="form.name"
        (input)="onNameInput()"
        [placeholder]="'UPLOAD_IMAGES.MODAL_TAGS_NAME_PLACEHOLDER' | translate"
        autocomplete="off"
      />
      <div class="error" *ngIf="duplicateError">{{ duplicateError }}</div>

      <label class="field-label" for="tag-description">
        {{ 'UPLOAD_IMAGES.MODAL_TAGS_DESCRIPTION' | translate }}
      </label>
      <textarea
        id="tag-description"
        pTextarea
        [autoResize]="true"
        [(ngModel)]="form.description"
        [placeholder]="'UPLOAD_IMAGES.MODAL_TAGS_DESCRIPTION_PLACEHOLDER' | translate"
        rows="3"
      ></textarea>

      <div class="checkbox-row" *ngIf="!disableVisibilityControls">
        <div class="checkbox-item">
          <p-checkbox
            inputId="tag-visible"
            [(ngModel)]="form.visible"
            binary="true"
          ></p-checkbox>
          <label for="tag-visible">{{ 'UPLOAD_IMAGES.MODAL_TAGS_VISIBLE' | translate }}</label>
        </div>
        <div class="checkbox-item">
          <p-checkbox
            inputId="tag-public"
            [(ngModel)]="form.isPublic"
            binary="true"
          ></p-checkbox>
          <label for="tag-public">{{ 'UPLOAD_IMAGES.MODAL_TAGS_PUBLISHED' | translate }}</label>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="footer-actions">
      <app-button
        variant="secondary"
        (onClick)="close()"
        [disabled]="saving"
      >
        {{ 'UPLOAD_IMAGES.MODAL_TAGS_CANCEL' | translate }}
      </app-button>
      <app-button
        variant="primary"
        [loading]="saving"
        [disabled]="!canSave"
        (onClick)="save()"
      >
        {{ 'UPLOAD_IMAGES.MODAL_TAGS_SAVE' | translate }}
      </app-button>
    </div>
  </ng-template>
</app-dialog>
